import React, { createContext, useContext, useReducer } from 'react';
interface CartItem {
  id: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
  // For apparel
  size?: string;
  color?: string;
  // For cannabis
  strain?: string;
  thc?: string;
}
interface CartState {
  items: CartItem[];
  total: number;
}
type CartAction = {
  type: 'ADD_ITEM';
  payload: CartItem;
} | {
  type: 'REMOVE_ITEM';
  payload: number;
} | {
  type: 'UPDATE_QUANTITY';
  payload: {
    id: number;
    quantity: number;
  };
} | {
  type: 'CLEAR_CART';
};
const cartReducer = (state: CartState, action: CartAction): CartState => {
  switch (action.type) {
    case 'ADD_ITEM':
      {
        const existingItem = state.items.find(item => item.id === action.payload.id);
        if (existingItem) {
          return {
            ...state,
            items: state.items.map(item => item.id === action.payload.id ? {
              ...item,
              quantity: item.quantity + 1
            } : item),
            total: state.total + action.payload.price
          };
        }
        return {
          ...state,
          items: [...state.items, action.payload],
          total: state.total + action.payload.price
        };
      }
    case 'REMOVE_ITEM':
      {
        const item = state.items.find(i => i.id === action.payload);
        return {
          ...state,
          items: state.items.filter(item => item.id !== action.payload),
          total: state.total - (item ? item.price * item.quantity : 0)
        };
      }
    case 'UPDATE_QUANTITY':
      {
        const item = state.items.find(i => i.id === action.payload.id);
        if (!item) return state;
        const quantityDiff = action.payload.quantity - item.quantity;
        return {
          ...state,
          items: state.items.map(item => item.id === action.payload.id ? {
            ...item,
            quantity: action.payload.quantity
          } : item),
          total: state.total + item.price * quantityDiff
        };
      }
    case 'CLEAR_CART':
      return {
        items: [],
        total: 0
      };
    default:
      return state;
  }
};
const CartContext = createContext<{
  state: CartState;
  dispatch: React.Dispatch<CartAction>;
} | null>(null);
export const CartProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [state, dispatch] = useReducer(cartReducer, {
    items: [],
    total: 0
  });
  return <CartContext.Provider value={{
    state,
    dispatch
  }} data-id="element-275">
      {children}
    </CartContext.Provider>;
};
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};